/* tslint:disable */
/* eslint-disable */
/**
 * grpc/v1/landings_service.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common'
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from '../base'
// @ts-ignore
import type { RequestArgs } from '../base'
// @ts-ignore
import { LandingsServiceUpdateLandingBody } from '../models'
// @ts-ignore
import { RpcStatus } from '../models'
// @ts-ignore
import { V1AddCampaignLinkResponse } from '../models'
// @ts-ignore
import { V1Campaign } from '../models'
// @ts-ignore
import { V1CampaignLink } from '../models'
// @ts-ignore
import { V1CreateCampaignResponse } from '../models'
// @ts-ignore
import { V1GetCampaignResponse } from '../models'
// @ts-ignore
import { V1GetDeployStatusResponse } from '../models'
// @ts-ignore
import { V1GetLandingContentResponse } from '../models'
// @ts-ignore
import { V1GetLandingResponse } from '../models'
// @ts-ignore
import { V1GetLandingSeoResponse } from '../models'
// @ts-ignore
import { V1GetPublishManifestResponse } from '../models'
// @ts-ignore
import { V1LandingSeo } from '../models'
// @ts-ignore
import { V1ListAttributionLabelsResponse } from '../models'
// @ts-ignore
import { V1ListCampaignsResponse } from '../models'
// @ts-ignore
import { V1ListLandingsResponse } from '../models'
// @ts-ignore
import { V1ListUTMDictionaryResponse } from '../models'
// @ts-ignore
import { V1PublishLandingResponse } from '../models'
// @ts-ignore
import { V1RecordLandingEventsRequest } from '../models'
// @ts-ignore
import { V1RecordLandingEventsResponse } from '../models'
// @ts-ignore
import { V1RecordLandingViewRequest } from '../models'
// @ts-ignore
import { V1RecordLandingViewResponse } from '../models'
// @ts-ignore
import { V1UTMDictionaryEntry } from '../models'
// @ts-ignore
import { V1UnpublishLandingResponse } from '../models'
// @ts-ignore
import { V1UpdateCampaignResponse } from '../models'
// @ts-ignore
import { V1UpdateLandingContentResponse } from '../models'
// @ts-ignore
import { V1UpdateLandingResponse } from '../models'
// @ts-ignore
import { V1UpdateLandingSeoResponse } from '../models'
// @ts-ignore
import { V1UpsertUTMDictionaryEntryResponse } from '../models'
/**
 * LandingsServiceApi - axios parameter creator
 * @export
 */
export const LandingsServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary AddCampaignLink — собрать и сохранить размеченную ссылку кампании. URL собирает сервис: собранный формой адрес уже уезжал в рассылку с меткой от другой площадки.
     * @param {string} campaignId
     * @param {V1CampaignLink} link
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceAddCampaignLink: async (
      campaignId: string,
      link: V1CampaignLink,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'campaignId' is not null or undefined
      assertParamExists('landingsServiceAddCampaignLink', 'campaignId', campaignId)
      // verify required parameter 'link' is not null or undefined
      assertParamExists('landingsServiceAddCampaignLink', 'link', link)
      const localVarPath = `/api/v1/landings/campaigns/{campaignId}/links`.replace(
        `{${'campaignId'}}`,
        encodeURIComponent(String(campaignId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        link,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary CreateCampaign — завести кампанию. Слаг уезжает в ссылку как utm_campaign.
     * @param {V1Campaign} campaign
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceCreateCampaign: async (
      campaign: V1Campaign,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'campaign' is not null or undefined
      assertParamExists('landingsServiceCreateCampaign', 'campaign', campaign)
      const localVarPath = `/api/v1/landings/campaigns`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        campaign,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary DeleteCampaignLink — убрать ссылку кампании. Переходы по ней остаются в фактах аналитики.
     * @param {string} campaignId
     * @param {string} linkId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceDeleteCampaignLink: async (
      campaignId: string,
      linkId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'campaignId' is not null or undefined
      assertParamExists('landingsServiceDeleteCampaignLink', 'campaignId', campaignId)
      // verify required parameter 'linkId' is not null or undefined
      assertParamExists('landingsServiceDeleteCampaignLink', 'linkId', linkId)
      const localVarPath = `/api/v1/landings/campaigns/{campaignId}/links/{linkId}`
        .replace(`{${'campaignId'}}`, encodeURIComponent(String(campaignId)))
        .replace(`{${'linkId'}}`, encodeURIComponent(String(linkId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary DeleteUTMDictionaryEntry — убрать значение из справочника.
     * @param {string} dimension
     * @param {string} value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceDeleteUTMDictionaryEntry: async (
      dimension: string,
      value: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dimension' is not null or undefined
      assertParamExists('landingsServiceDeleteUTMDictionaryEntry', 'dimension', dimension)
      // verify required parameter 'value' is not null or undefined
      assertParamExists('landingsServiceDeleteUTMDictionaryEntry', 'value', value)
      const localVarPath = `/api/v1/landings/utm-dictionary/{dimension}/{value}`
        .replace(`{${'dimension'}}`, encodeURIComponent(String(dimension)))
        .replace(`{${'value'}}`, encodeURIComponent(String(value)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetCampaign — кампания со своими ссылками.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceGetCampaign: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('landingsServiceGetCampaign', 'id', id)
      const localVarPath = `/api/v1/landings/campaigns/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetDeployStatus — последний deploy-статус лендинга (из БД, по имени).
     * @param {string} name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceGetDeployStatus: async (
      name: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'name' is not null or undefined
      assertParamExists('landingsServiceGetDeployStatus', 'name', name)
      const localVarPath = `/api/v1/landings/{name}/status`.replace(
        `{${'name'}}`,
        encodeURIComponent(String(name)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetLanding — один лендинг по имени.
     * @param {string} name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceGetLanding: async (
      name: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'name' is not null or undefined
      assertParamExists('landingsServiceGetLanding', 'name', name)
      const localVarPath = `/api/v1/landings/{name}`.replace(
        `{${'name'}}`,
        encodeURIComponent(String(name)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetLandingContent — слоты контента лендинга (DEV-2375, ADR-0063): схема из landings/<name>/content.json репо лендингов, значения из CRM поверх дефолтов и снимок последней публикации. has_schema=false — слотов у лендинга нет (нет файла или площадка обезличенная), это не ошибка.
     * @param {string} name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceGetLandingContent: async (
      name: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'name' is not null or undefined
      assertParamExists('landingsServiceGetLandingContent', 'name', name)
      const localVarPath = `/api/v1/landings/{name}/content`.replace(
        `{${'name'}}`,
        encodeURIComponent(String(name)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetLandingSeo — настройки индексации и мета-тегов лендинга (DEV-1783, ADR-0048).
     * @param {string} name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceGetLandingSeo: async (
      name: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'name' is not null or undefined
      assertParamExists('landingsServiceGetLandingSeo', 'name', name)
      const localVarPath = `/api/v1/landings/{name}/seo`.replace(
        `{${'name'}}`,
        encodeURIComponent(String(name)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetPublishManifest — то, что уедет на прод при следующей публикации: готовый набор тегов страницы и флаг включения в карту сайта. Читает CRM («что уедет на прод») и переносит в вёрстку джоба публикации.
     * @param {string} name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceGetPublishManifest: async (
      name: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'name' is not null or undefined
      assertParamExists('landingsServiceGetPublishManifest', 'name', name)
      const localVarPath = `/api/v1/landings/{name}/manifest`.replace(
        `{${'name'}}`,
        encodeURIComponent(String(name)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Любому вошедшему, без landings:read: фильтр нужен менеджерам, а права на раздел маркетинга у них нет. Отдаются только слаг и название — ни расхода, ни ссылок, ни адресов. Объявлен последним: статический путь обязан перехватить запрос раньше catch-all /api/v1/landings/{name}.
     * @summary ListAttributionLabels — человеческие названия площадок и кампаний для фильтра «Источник» в CRM (DEV-2301).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceListAttributionLabels: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/landings/attribution-labels`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Объявлены ПОСЛЕ справочника по той же причине, что и он сам: gateway регистрирует обработчики prepend\'ом, и статический /campaigns обязан перехватить запрос раньше catch-all /api/v1/landings/{name}. Порядок закреплён тестом routing_order_test.
     * @summary Кампании и их размеченные ссылки (DEV-1854).
     * @param {boolean} [includeInactive] include_inactive — показать закрытые кампании. Форме выбора они не нужны, списку кампаний — нужны.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceListCampaigns: async (
      includeInactive?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/landings/campaigns`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (includeInactive !== undefined) {
        localVarQueryParameter['includeInactive'] = includeInactive
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary ListLandings — список лендингов из registry.yaml.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceListLandings: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/landings`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary ListUTMDictionary — допустимые значения меток кампании (DEV-1844). Объявлен ПОСЛЕ GetLanding намеренно: grpc-gateway регистрирует обработчики prepend\'ом, и объявленный позже статический путь перехватывает запрос раньше catch-all /api/v1/landings/{name}. Порядок закреплён тестом.
     * @param {string} [dimension] пусто — все измерения сразу
     * @param {boolean} [includeInactive] include_inactive — показать снятые с эфира значения. Форме выбора они не нужны, экрану управления справочником — нужны.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceListUTMDictionary: async (
      dimension?: string,
      includeInactive?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/landings/utm-dictionary`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (dimension !== undefined) {
        localVarQueryParameter['dimension'] = dimension
      }

      if (includeInactive !== undefined) {
        localVarQueryParameter['includeInactive'] = includeInactive
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary PublishLanding — триггер публикации (ACTION=publish).
     * @param {string} name
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServicePublishLanding: async (
      name: string,
      body: object,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'name' is not null or undefined
      assertParamExists('landingsServicePublishLanding', 'name', name)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('landingsServicePublishLanding', 'body', body)
      const localVarPath = `/api/v1/landings/{name}/publish`.replace(
        `{${'name'}}`,
        encodeURIComponent(String(name)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * ПУБЛИЧНЫЙ метод без авторизации, как и приём просмотра: бьёт скрипт vp-metrics с площадки, в том числе с чужого домена застройщика.  Пачкой, а не по одному: за визит набегают десятки прокруток и кликов, и отдельный запрос на каждый превратил бы приёмник в мишень на ровном месте.  Тот же осознанный риск ADR, что у просмотров: события накручиваемы. Портят только внутреннюю метрику, PII метод не принимает и не хранит.
     * @summary RecordLandingEvents — что посетитель делал на странице (DEV-1865).
     * @param {V1RecordLandingEventsRequest} body RecordLandingEventsRequest — пачка взаимодействий с одной страницы.  Времени в событиях нет намеренно, по той же причине, что и у просмотра: метод публичный, клиентским часам в фактах аналитики доверять нельзя — timestamp ставит приёмник.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceRecordLandingEvents: async (
      body: V1RecordLandingEventsRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('landingsServiceRecordLandingEvents', 'body', body)
      const localVarPath = `/api/v1/landings/events`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Осознанный риск ADR: просмотры накручиваемы. Портит только внутреннюю метрику, PII метод не принимает и не хранит.
     * @summary RecordLandingView — приём просмотра лендинга (DEV-1086, ADR-0022 ред.2 §3.5). ПУБЛИЧНЫЙ метод без авторизации: бьют middleware Cloudflare Pages (внешний рекламный лендинг) и beacon GCS-лендингов. Событие уходит в шину через outbox, analytics считает конверсию по слагу.
     * @param {V1RecordLandingViewRequest} body RecordLandingViewRequest — один просмотр лендинга.  Времени просмотра в запросе нет намеренно: метод публичный, клиентскому времени в фактах аналитики доверять нельзя — timestamp ставит приёмник. Тело от Pages Function содержит лишнее поле viewed_at, gateway его гасит (DiscardUnknown), и это ожидаемо.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceRecordLandingView: async (
      body: V1RecordLandingViewRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('landingsServiceRecordLandingView', 'body', body)
      const localVarPath = `/api/v1/landings/views`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary UnpublishLanding — триггер снятия (ACTION=unpublish).
     * @param {string} name
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceUnpublishLanding: async (
      name: string,
      body: object,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'name' is not null or undefined
      assertParamExists('landingsServiceUnpublishLanding', 'name', name)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('landingsServiceUnpublishLanding', 'body', body)
      const localVarPath = `/api/v1/landings/{name}/unpublish`.replace(
        `{${'name'}}`,
        encodeURIComponent(String(name)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary UpdateCampaign — правка кампании. Слаг неизменяем, цель — пока нет ссылок.
     * @param {string} id
     * @param {V1Campaign} campaign
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceUpdateCampaign: async (
      id: string,
      campaign: V1Campaign,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('landingsServiceUpdateCampaign', 'id', id)
      // verify required parameter 'campaign' is not null or undefined
      assertParamExists('landingsServiceUpdateCampaign', 'campaign', campaign)
      const localVarPath = `/api/v1/landings/campaigns/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        campaign,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Каталог остаётся в registry.yaml, но название оттуда меняется только коммитом в frontend/landings, а описания там нет вовсе. Правка ложится в БД поверх каталога: пустой title возвращает название из реестра.
     * @summary UpdateLanding — правка карточки площадки из CRM: название и описание.
     * @param {string} name
     * @param {LandingsServiceUpdateLandingBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceUpdateLanding: async (
      name: string,
      body: LandingsServiceUpdateLandingBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'name' is not null or undefined
      assertParamExists('landingsServiceUpdateLanding', 'name', name)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('landingsServiceUpdateLanding', 'body', body)
      const localVarPath = `/api/v1/landings/{name}`.replace(
        `{${'name'}}`,
        encodeURIComponent(String(name)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary UpdateLandingContent — полная замена значений слотов. Пустое значение или отсутствие ключа = «как в коде»; значения проверяются по схеме, незнакомый ключ отклоняется. На страницу значения попадают при публикации.
     * @param {string} name
     * @param {object} values values — ключ слота → значение; пустая строка или отсутствие ключа &#x3D; «как в коде».
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceUpdateLandingContent: async (
      name: string,
      values: object,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'name' is not null or undefined
      assertParamExists('landingsServiceUpdateLandingContent', 'name', name)
      // verify required parameter 'values' is not null or undefined
      assertParamExists('landingsServiceUpdateLandingContent', 'values', values)
      const localVarPath = `/api/v1/landings/{name}/content`.replace(
        `{${'name'}}`,
        encodeURIComponent(String(name)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        values,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary UpdateLandingSeo — полная замена настроек SEO лендинга.
     * @param {string} name
     * @param {V1LandingSeo} seo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceUpdateLandingSeo: async (
      name: string,
      seo: V1LandingSeo,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'name' is not null or undefined
      assertParamExists('landingsServiceUpdateLandingSeo', 'name', name)
      // verify required parameter 'seo' is not null or undefined
      assertParamExists('landingsServiceUpdateLandingSeo', 'seo', seo)
      const localVarPath = `/api/v1/landings/{name}/seo`.replace(
        `{${'name'}}`,
        encodeURIComponent(String(name)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        seo,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary UpsertUTMDictionaryEntry — завести или изменить значение справочника.
     * @param {V1UTMDictionaryEntry} entry
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceUpsertUTMDictionaryEntry: async (
      entry: V1UTMDictionaryEntry,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'entry' is not null or undefined
      assertParamExists('landingsServiceUpsertUTMDictionaryEntry', 'entry', entry)
      const localVarPath = `/api/v1/landings/utm-dictionary`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        entry,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * LandingsServiceApi - functional programming interface
 * @export
 */
export const LandingsServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = LandingsServiceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary AddCampaignLink — собрать и сохранить размеченную ссылку кампании. URL собирает сервис: собранный формой адрес уже уезжал в рассылку с меткой от другой площадки.
     * @param {string} campaignId
     * @param {V1CampaignLink} link
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async landingsServiceAddCampaignLink(
      campaignId: string,
      link: V1CampaignLink,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AddCampaignLinkResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.landingsServiceAddCampaignLink(
        campaignId,
        link,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LandingsServiceApi.landingsServiceAddCampaignLink']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary CreateCampaign — завести кампанию. Слаг уезжает в ссылку как utm_campaign.
     * @param {V1Campaign} campaign
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async landingsServiceCreateCampaign(
      campaign: V1Campaign,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CreateCampaignResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.landingsServiceCreateCampaign(
        campaign,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LandingsServiceApi.landingsServiceCreateCampaign']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary DeleteCampaignLink — убрать ссылку кампании. Переходы по ней остаются в фактах аналитики.
     * @param {string} campaignId
     * @param {string} linkId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async landingsServiceDeleteCampaignLink(
      campaignId: string,
      linkId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.landingsServiceDeleteCampaignLink(
        campaignId,
        linkId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LandingsServiceApi.landingsServiceDeleteCampaignLink']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary DeleteUTMDictionaryEntry — убрать значение из справочника.
     * @param {string} dimension
     * @param {string} value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async landingsServiceDeleteUTMDictionaryEntry(
      dimension: string,
      value: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.landingsServiceDeleteUTMDictionaryEntry(
          dimension,
          value,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LandingsServiceApi.landingsServiceDeleteUTMDictionaryEntry']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetCampaign — кампания со своими ссылками.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async landingsServiceGetCampaign(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetCampaignResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.landingsServiceGetCampaign(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LandingsServiceApi.landingsServiceGetCampaign']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetDeployStatus — последний deploy-статус лендинга (из БД, по имени).
     * @param {string} name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async landingsServiceGetDeployStatus(
      name: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetDeployStatusResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.landingsServiceGetDeployStatus(
        name,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LandingsServiceApi.landingsServiceGetDeployStatus']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetLanding — один лендинг по имени.
     * @param {string} name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async landingsServiceGetLanding(
      name: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetLandingResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.landingsServiceGetLanding(
        name,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LandingsServiceApi.landingsServiceGetLanding']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetLandingContent — слоты контента лендинга (DEV-2375, ADR-0063): схема из landings/<name>/content.json репо лендингов, значения из CRM поверх дефолтов и снимок последней публикации. has_schema=false — слотов у лендинга нет (нет файла или площадка обезличенная), это не ошибка.
     * @param {string} name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async landingsServiceGetLandingContent(
      name: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetLandingContentResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.landingsServiceGetLandingContent(
        name,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LandingsServiceApi.landingsServiceGetLandingContent']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetLandingSeo — настройки индексации и мета-тегов лендинга (DEV-1783, ADR-0048).
     * @param {string} name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async landingsServiceGetLandingSeo(
      name: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetLandingSeoResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.landingsServiceGetLandingSeo(
        name,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LandingsServiceApi.landingsServiceGetLandingSeo']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetPublishManifest — то, что уедет на прод при следующей публикации: готовый набор тегов страницы и флаг включения в карту сайта. Читает CRM («что уедет на прод») и переносит в вёрстку джоба публикации.
     * @param {string} name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async landingsServiceGetPublishManifest(
      name: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetPublishManifestResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.landingsServiceGetPublishManifest(
        name,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LandingsServiceApi.landingsServiceGetPublishManifest']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Любому вошедшему, без landings:read: фильтр нужен менеджерам, а права на раздел маркетинга у них нет. Отдаются только слаг и название — ни расхода, ни ссылок, ни адресов. Объявлен последним: статический путь обязан перехватить запрос раньше catch-all /api/v1/landings/{name}.
     * @summary ListAttributionLabels — человеческие названия площадок и кампаний для фильтра «Источник» в CRM (DEV-2301).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async landingsServiceListAttributionLabels(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListAttributionLabelsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.landingsServiceListAttributionLabels(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LandingsServiceApi.landingsServiceListAttributionLabels']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Объявлены ПОСЛЕ справочника по той же причине, что и он сам: gateway регистрирует обработчики prepend\'ом, и статический /campaigns обязан перехватить запрос раньше catch-all /api/v1/landings/{name}. Порядок закреплён тестом routing_order_test.
     * @summary Кампании и их размеченные ссылки (DEV-1854).
     * @param {boolean} [includeInactive] include_inactive — показать закрытые кампании. Форме выбора они не нужны, списку кампаний — нужны.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async landingsServiceListCampaigns(
      includeInactive?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListCampaignsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.landingsServiceListCampaigns(
        includeInactive,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LandingsServiceApi.landingsServiceListCampaigns']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary ListLandings — список лендингов из registry.yaml.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async landingsServiceListLandings(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListLandingsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.landingsServiceListLandings(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LandingsServiceApi.landingsServiceListLandings']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary ListUTMDictionary — допустимые значения меток кампании (DEV-1844). Объявлен ПОСЛЕ GetLanding намеренно: grpc-gateway регистрирует обработчики prepend\'ом, и объявленный позже статический путь перехватывает запрос раньше catch-all /api/v1/landings/{name}. Порядок закреплён тестом.
     * @param {string} [dimension] пусто — все измерения сразу
     * @param {boolean} [includeInactive] include_inactive — показать снятые с эфира значения. Форме выбора они не нужны, экрану управления справочником — нужны.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async landingsServiceListUTMDictionary(
      dimension?: string,
      includeInactive?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListUTMDictionaryResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.landingsServiceListUTMDictionary(
        dimension,
        includeInactive,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LandingsServiceApi.landingsServiceListUTMDictionary']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary PublishLanding — триггер публикации (ACTION=publish).
     * @param {string} name
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async landingsServicePublishLanding(
      name: string,
      body: object,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PublishLandingResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.landingsServicePublishLanding(
        name,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LandingsServiceApi.landingsServicePublishLanding']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * ПУБЛИЧНЫЙ метод без авторизации, как и приём просмотра: бьёт скрипт vp-metrics с площадки, в том числе с чужого домена застройщика.  Пачкой, а не по одному: за визит набегают десятки прокруток и кликов, и отдельный запрос на каждый превратил бы приёмник в мишень на ровном месте.  Тот же осознанный риск ADR, что у просмотров: события накручиваемы. Портят только внутреннюю метрику, PII метод не принимает и не хранит.
     * @summary RecordLandingEvents — что посетитель делал на странице (DEV-1865).
     * @param {V1RecordLandingEventsRequest} body RecordLandingEventsRequest — пачка взаимодействий с одной страницы.  Времени в событиях нет намеренно, по той же причине, что и у просмотра: метод публичный, клиентским часам в фактах аналитики доверять нельзя — timestamp ставит приёмник.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async landingsServiceRecordLandingEvents(
      body: V1RecordLandingEventsRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1RecordLandingEventsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.landingsServiceRecordLandingEvents(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LandingsServiceApi.landingsServiceRecordLandingEvents']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Осознанный риск ADR: просмотры накручиваемы. Портит только внутреннюю метрику, PII метод не принимает и не хранит.
     * @summary RecordLandingView — приём просмотра лендинга (DEV-1086, ADR-0022 ред.2 §3.5). ПУБЛИЧНЫЙ метод без авторизации: бьют middleware Cloudflare Pages (внешний рекламный лендинг) и beacon GCS-лендингов. Событие уходит в шину через outbox, analytics считает конверсию по слагу.
     * @param {V1RecordLandingViewRequest} body RecordLandingViewRequest — один просмотр лендинга.  Времени просмотра в запросе нет намеренно: метод публичный, клиентскому времени в фактах аналитики доверять нельзя — timestamp ставит приёмник. Тело от Pages Function содержит лишнее поле viewed_at, gateway его гасит (DiscardUnknown), и это ожидаемо.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async landingsServiceRecordLandingView(
      body: V1RecordLandingViewRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1RecordLandingViewResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.landingsServiceRecordLandingView(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LandingsServiceApi.landingsServiceRecordLandingView']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary UnpublishLanding — триггер снятия (ACTION=unpublish).
     * @param {string} name
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async landingsServiceUnpublishLanding(
      name: string,
      body: object,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1UnpublishLandingResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.landingsServiceUnpublishLanding(
        name,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LandingsServiceApi.landingsServiceUnpublishLanding']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary UpdateCampaign — правка кампании. Слаг неизменяем, цель — пока нет ссылок.
     * @param {string} id
     * @param {V1Campaign} campaign
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async landingsServiceUpdateCampaign(
      id: string,
      campaign: V1Campaign,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1UpdateCampaignResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.landingsServiceUpdateCampaign(
        id,
        campaign,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LandingsServiceApi.landingsServiceUpdateCampaign']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Каталог остаётся в registry.yaml, но название оттуда меняется только коммитом в frontend/landings, а описания там нет вовсе. Правка ложится в БД поверх каталога: пустой title возвращает название из реестра.
     * @summary UpdateLanding — правка карточки площадки из CRM: название и описание.
     * @param {string} name
     * @param {LandingsServiceUpdateLandingBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async landingsServiceUpdateLanding(
      name: string,
      body: LandingsServiceUpdateLandingBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1UpdateLandingResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.landingsServiceUpdateLanding(
        name,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LandingsServiceApi.landingsServiceUpdateLanding']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary UpdateLandingContent — полная замена значений слотов. Пустое значение или отсутствие ключа = «как в коде»; значения проверяются по схеме, незнакомый ключ отклоняется. На страницу значения попадают при публикации.
     * @param {string} name
     * @param {object} values values — ключ слота → значение; пустая строка или отсутствие ключа &#x3D; «как в коде».
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async landingsServiceUpdateLandingContent(
      name: string,
      values: object,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1UpdateLandingContentResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.landingsServiceUpdateLandingContent(
        name,
        values,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LandingsServiceApi.landingsServiceUpdateLandingContent']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary UpdateLandingSeo — полная замена настроек SEO лендинга.
     * @param {string} name
     * @param {V1LandingSeo} seo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async landingsServiceUpdateLandingSeo(
      name: string,
      seo: V1LandingSeo,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1UpdateLandingSeoResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.landingsServiceUpdateLandingSeo(
        name,
        seo,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LandingsServiceApi.landingsServiceUpdateLandingSeo']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary UpsertUTMDictionaryEntry — завести или изменить значение справочника.
     * @param {V1UTMDictionaryEntry} entry
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async landingsServiceUpsertUTMDictionaryEntry(
      entry: V1UTMDictionaryEntry,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1UpsertUTMDictionaryEntryResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.landingsServiceUpsertUTMDictionaryEntry(entry, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['LandingsServiceApi.landingsServiceUpsertUTMDictionaryEntry']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * LandingsServiceApi - factory interface
 * @export
 */
export const LandingsServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = LandingsServiceApiFp(configuration)
  return {
    /**
     *
     * @summary AddCampaignLink — собрать и сохранить размеченную ссылку кампании. URL собирает сервис: собранный формой адрес уже уезжал в рассылку с меткой от другой площадки.
     * @param {string} campaignId
     * @param {V1CampaignLink} link
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceAddCampaignLink(
      campaignId: string,
      link: V1CampaignLink,
      options?: any,
    ): AxiosPromise<V1AddCampaignLinkResponse> {
      return localVarFp
        .landingsServiceAddCampaignLink(campaignId, link, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary CreateCampaign — завести кампанию. Слаг уезжает в ссылку как utm_campaign.
     * @param {V1Campaign} campaign
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceCreateCampaign(
      campaign: V1Campaign,
      options?: any,
    ): AxiosPromise<V1CreateCampaignResponse> {
      return localVarFp
        .landingsServiceCreateCampaign(campaign, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary DeleteCampaignLink — убрать ссылку кампании. Переходы по ней остаются в фактах аналитики.
     * @param {string} campaignId
     * @param {string} linkId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceDeleteCampaignLink(
      campaignId: string,
      linkId: string,
      options?: any,
    ): AxiosPromise<object> {
      return localVarFp
        .landingsServiceDeleteCampaignLink(campaignId, linkId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary DeleteUTMDictionaryEntry — убрать значение из справочника.
     * @param {string} dimension
     * @param {string} value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceDeleteUTMDictionaryEntry(
      dimension: string,
      value: string,
      options?: any,
    ): AxiosPromise<object> {
      return localVarFp
        .landingsServiceDeleteUTMDictionaryEntry(dimension, value, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetCampaign — кампания со своими ссылками.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceGetCampaign(id: string, options?: any): AxiosPromise<V1GetCampaignResponse> {
      return localVarFp
        .landingsServiceGetCampaign(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetDeployStatus — последний deploy-статус лендинга (из БД, по имени).
     * @param {string} name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceGetDeployStatus(
      name: string,
      options?: any,
    ): AxiosPromise<V1GetDeployStatusResponse> {
      return localVarFp
        .landingsServiceGetDeployStatus(name, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetLanding — один лендинг по имени.
     * @param {string} name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceGetLanding(name: string, options?: any): AxiosPromise<V1GetLandingResponse> {
      return localVarFp
        .landingsServiceGetLanding(name, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetLandingContent — слоты контента лендинга (DEV-2375, ADR-0063): схема из landings/<name>/content.json репо лендингов, значения из CRM поверх дефолтов и снимок последней публикации. has_schema=false — слотов у лендинга нет (нет файла или площадка обезличенная), это не ошибка.
     * @param {string} name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceGetLandingContent(
      name: string,
      options?: any,
    ): AxiosPromise<V1GetLandingContentResponse> {
      return localVarFp
        .landingsServiceGetLandingContent(name, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetLandingSeo — настройки индексации и мета-тегов лендинга (DEV-1783, ADR-0048).
     * @param {string} name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceGetLandingSeo(
      name: string,
      options?: any,
    ): AxiosPromise<V1GetLandingSeoResponse> {
      return localVarFp
        .landingsServiceGetLandingSeo(name, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetPublishManifest — то, что уедет на прод при следующей публикации: готовый набор тегов страницы и флаг включения в карту сайта. Читает CRM («что уедет на прод») и переносит в вёрстку джоба публикации.
     * @param {string} name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceGetPublishManifest(
      name: string,
      options?: any,
    ): AxiosPromise<V1GetPublishManifestResponse> {
      return localVarFp
        .landingsServiceGetPublishManifest(name, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Любому вошедшему, без landings:read: фильтр нужен менеджерам, а права на раздел маркетинга у них нет. Отдаются только слаг и название — ни расхода, ни ссылок, ни адресов. Объявлен последним: статический путь обязан перехватить запрос раньше catch-all /api/v1/landings/{name}.
     * @summary ListAttributionLabels — человеческие названия площадок и кампаний для фильтра «Источник» в CRM (DEV-2301).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceListAttributionLabels(
      options?: any,
    ): AxiosPromise<V1ListAttributionLabelsResponse> {
      return localVarFp
        .landingsServiceListAttributionLabels(options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Объявлены ПОСЛЕ справочника по той же причине, что и он сам: gateway регистрирует обработчики prepend\'ом, и статический /campaigns обязан перехватить запрос раньше catch-all /api/v1/landings/{name}. Порядок закреплён тестом routing_order_test.
     * @summary Кампании и их размеченные ссылки (DEV-1854).
     * @param {boolean} [includeInactive] include_inactive — показать закрытые кампании. Форме выбора они не нужны, списку кампаний — нужны.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceListCampaigns(
      includeInactive?: boolean,
      options?: any,
    ): AxiosPromise<V1ListCampaignsResponse> {
      return localVarFp
        .landingsServiceListCampaigns(includeInactive, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary ListLandings — список лендингов из registry.yaml.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceListLandings(options?: any): AxiosPromise<V1ListLandingsResponse> {
      return localVarFp
        .landingsServiceListLandings(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary ListUTMDictionary — допустимые значения меток кампании (DEV-1844). Объявлен ПОСЛЕ GetLanding намеренно: grpc-gateway регистрирует обработчики prepend\'ом, и объявленный позже статический путь перехватывает запрос раньше catch-all /api/v1/landings/{name}. Порядок закреплён тестом.
     * @param {string} [dimension] пусто — все измерения сразу
     * @param {boolean} [includeInactive] include_inactive — показать снятые с эфира значения. Форме выбора они не нужны, экрану управления справочником — нужны.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceListUTMDictionary(
      dimension?: string,
      includeInactive?: boolean,
      options?: any,
    ): AxiosPromise<V1ListUTMDictionaryResponse> {
      return localVarFp
        .landingsServiceListUTMDictionary(dimension, includeInactive, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary PublishLanding — триггер публикации (ACTION=publish).
     * @param {string} name
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServicePublishLanding(
      name: string,
      body: object,
      options?: any,
    ): AxiosPromise<V1PublishLandingResponse> {
      return localVarFp
        .landingsServicePublishLanding(name, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * ПУБЛИЧНЫЙ метод без авторизации, как и приём просмотра: бьёт скрипт vp-metrics с площадки, в том числе с чужого домена застройщика.  Пачкой, а не по одному: за визит набегают десятки прокруток и кликов, и отдельный запрос на каждый превратил бы приёмник в мишень на ровном месте.  Тот же осознанный риск ADR, что у просмотров: события накручиваемы. Портят только внутреннюю метрику, PII метод не принимает и не хранит.
     * @summary RecordLandingEvents — что посетитель делал на странице (DEV-1865).
     * @param {V1RecordLandingEventsRequest} body RecordLandingEventsRequest — пачка взаимодействий с одной страницы.  Времени в событиях нет намеренно, по той же причине, что и у просмотра: метод публичный, клиентским часам в фактах аналитики доверять нельзя — timestamp ставит приёмник.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceRecordLandingEvents(
      body: V1RecordLandingEventsRequest,
      options?: any,
    ): AxiosPromise<V1RecordLandingEventsResponse> {
      return localVarFp
        .landingsServiceRecordLandingEvents(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Осознанный риск ADR: просмотры накручиваемы. Портит только внутреннюю метрику, PII метод не принимает и не хранит.
     * @summary RecordLandingView — приём просмотра лендинга (DEV-1086, ADR-0022 ред.2 §3.5). ПУБЛИЧНЫЙ метод без авторизации: бьют middleware Cloudflare Pages (внешний рекламный лендинг) и beacon GCS-лендингов. Событие уходит в шину через outbox, analytics считает конверсию по слагу.
     * @param {V1RecordLandingViewRequest} body RecordLandingViewRequest — один просмотр лендинга.  Времени просмотра в запросе нет намеренно: метод публичный, клиентскому времени в фактах аналитики доверять нельзя — timestamp ставит приёмник. Тело от Pages Function содержит лишнее поле viewed_at, gateway его гасит (DiscardUnknown), и это ожидаемо.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceRecordLandingView(
      body: V1RecordLandingViewRequest,
      options?: any,
    ): AxiosPromise<V1RecordLandingViewResponse> {
      return localVarFp
        .landingsServiceRecordLandingView(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary UnpublishLanding — триггер снятия (ACTION=unpublish).
     * @param {string} name
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceUnpublishLanding(
      name: string,
      body: object,
      options?: any,
    ): AxiosPromise<V1UnpublishLandingResponse> {
      return localVarFp
        .landingsServiceUnpublishLanding(name, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary UpdateCampaign — правка кампании. Слаг неизменяем, цель — пока нет ссылок.
     * @param {string} id
     * @param {V1Campaign} campaign
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceUpdateCampaign(
      id: string,
      campaign: V1Campaign,
      options?: any,
    ): AxiosPromise<V1UpdateCampaignResponse> {
      return localVarFp
        .landingsServiceUpdateCampaign(id, campaign, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Каталог остаётся в registry.yaml, но название оттуда меняется только коммитом в frontend/landings, а описания там нет вовсе. Правка ложится в БД поверх каталога: пустой title возвращает название из реестра.
     * @summary UpdateLanding — правка карточки площадки из CRM: название и описание.
     * @param {string} name
     * @param {LandingsServiceUpdateLandingBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceUpdateLanding(
      name: string,
      body: LandingsServiceUpdateLandingBody,
      options?: any,
    ): AxiosPromise<V1UpdateLandingResponse> {
      return localVarFp
        .landingsServiceUpdateLanding(name, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary UpdateLandingContent — полная замена значений слотов. Пустое значение или отсутствие ключа = «как в коде»; значения проверяются по схеме, незнакомый ключ отклоняется. На страницу значения попадают при публикации.
     * @param {string} name
     * @param {object} values values — ключ слота → значение; пустая строка или отсутствие ключа &#x3D; «как в коде».
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceUpdateLandingContent(
      name: string,
      values: object,
      options?: any,
    ): AxiosPromise<V1UpdateLandingContentResponse> {
      return localVarFp
        .landingsServiceUpdateLandingContent(name, values, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary UpdateLandingSeo — полная замена настроек SEO лендинга.
     * @param {string} name
     * @param {V1LandingSeo} seo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceUpdateLandingSeo(
      name: string,
      seo: V1LandingSeo,
      options?: any,
    ): AxiosPromise<V1UpdateLandingSeoResponse> {
      return localVarFp
        .landingsServiceUpdateLandingSeo(name, seo, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary UpsertUTMDictionaryEntry — завести или изменить значение справочника.
     * @param {V1UTMDictionaryEntry} entry
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    landingsServiceUpsertUTMDictionaryEntry(
      entry: V1UTMDictionaryEntry,
      options?: any,
    ): AxiosPromise<V1UpsertUTMDictionaryEntryResponse> {
      return localVarFp
        .landingsServiceUpsertUTMDictionaryEntry(entry, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * LandingsServiceApi - object-oriented interface
 * @export
 * @class LandingsServiceApi
 * @extends {BaseAPI}
 */
export class LandingsServiceApi extends BaseAPI {
  /**
   *
   * @summary AddCampaignLink — собрать и сохранить размеченную ссылку кампании. URL собирает сервис: собранный формой адрес уже уезжал в рассылку с меткой от другой площадки.
   * @param {string} campaignId
   * @param {V1CampaignLink} link
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LandingsServiceApi
   */
  public landingsServiceAddCampaignLink(
    campaignId: string,
    link: V1CampaignLink,
    options?: RawAxiosRequestConfig,
  ) {
    return LandingsServiceApiFp(this.configuration)
      .landingsServiceAddCampaignLink(campaignId, link, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary CreateCampaign — завести кампанию. Слаг уезжает в ссылку как utm_campaign.
   * @param {V1Campaign} campaign
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LandingsServiceApi
   */
  public landingsServiceCreateCampaign(campaign: V1Campaign, options?: RawAxiosRequestConfig) {
    return LandingsServiceApiFp(this.configuration)
      .landingsServiceCreateCampaign(campaign, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary DeleteCampaignLink — убрать ссылку кампании. Переходы по ней остаются в фактах аналитики.
   * @param {string} campaignId
   * @param {string} linkId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LandingsServiceApi
   */
  public landingsServiceDeleteCampaignLink(
    campaignId: string,
    linkId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return LandingsServiceApiFp(this.configuration)
      .landingsServiceDeleteCampaignLink(campaignId, linkId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary DeleteUTMDictionaryEntry — убрать значение из справочника.
   * @param {string} dimension
   * @param {string} value
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LandingsServiceApi
   */
  public landingsServiceDeleteUTMDictionaryEntry(
    dimension: string,
    value: string,
    options?: RawAxiosRequestConfig,
  ) {
    return LandingsServiceApiFp(this.configuration)
      .landingsServiceDeleteUTMDictionaryEntry(dimension, value, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetCampaign — кампания со своими ссылками.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LandingsServiceApi
   */
  public landingsServiceGetCampaign(id: string, options?: RawAxiosRequestConfig) {
    return LandingsServiceApiFp(this.configuration)
      .landingsServiceGetCampaign(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetDeployStatus — последний deploy-статус лендинга (из БД, по имени).
   * @param {string} name
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LandingsServiceApi
   */
  public landingsServiceGetDeployStatus(name: string, options?: RawAxiosRequestConfig) {
    return LandingsServiceApiFp(this.configuration)
      .landingsServiceGetDeployStatus(name, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetLanding — один лендинг по имени.
   * @param {string} name
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LandingsServiceApi
   */
  public landingsServiceGetLanding(name: string, options?: RawAxiosRequestConfig) {
    return LandingsServiceApiFp(this.configuration)
      .landingsServiceGetLanding(name, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetLandingContent — слоты контента лендинга (DEV-2375, ADR-0063): схема из landings/<name>/content.json репо лендингов, значения из CRM поверх дефолтов и снимок последней публикации. has_schema=false — слотов у лендинга нет (нет файла или площадка обезличенная), это не ошибка.
   * @param {string} name
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LandingsServiceApi
   */
  public landingsServiceGetLandingContent(name: string, options?: RawAxiosRequestConfig) {
    return LandingsServiceApiFp(this.configuration)
      .landingsServiceGetLandingContent(name, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetLandingSeo — настройки индексации и мета-тегов лендинга (DEV-1783, ADR-0048).
   * @param {string} name
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LandingsServiceApi
   */
  public landingsServiceGetLandingSeo(name: string, options?: RawAxiosRequestConfig) {
    return LandingsServiceApiFp(this.configuration)
      .landingsServiceGetLandingSeo(name, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetPublishManifest — то, что уедет на прод при следующей публикации: готовый набор тегов страницы и флаг включения в карту сайта. Читает CRM («что уедет на прод») и переносит в вёрстку джоба публикации.
   * @param {string} name
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LandingsServiceApi
   */
  public landingsServiceGetPublishManifest(name: string, options?: RawAxiosRequestConfig) {
    return LandingsServiceApiFp(this.configuration)
      .landingsServiceGetPublishManifest(name, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Любому вошедшему, без landings:read: фильтр нужен менеджерам, а права на раздел маркетинга у них нет. Отдаются только слаг и название — ни расхода, ни ссылок, ни адресов. Объявлен последним: статический путь обязан перехватить запрос раньше catch-all /api/v1/landings/{name}.
   * @summary ListAttributionLabels — человеческие названия площадок и кампаний для фильтра «Источник» в CRM (DEV-2301).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LandingsServiceApi
   */
  public landingsServiceListAttributionLabels(options?: RawAxiosRequestConfig) {
    return LandingsServiceApiFp(this.configuration)
      .landingsServiceListAttributionLabels(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Объявлены ПОСЛЕ справочника по той же причине, что и он сам: gateway регистрирует обработчики prepend\'ом, и статический /campaigns обязан перехватить запрос раньше catch-all /api/v1/landings/{name}. Порядок закреплён тестом routing_order_test.
   * @summary Кампании и их размеченные ссылки (DEV-1854).
   * @param {boolean} [includeInactive] include_inactive — показать закрытые кампании. Форме выбора они не нужны, списку кампаний — нужны.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LandingsServiceApi
   */
  public landingsServiceListCampaigns(includeInactive?: boolean, options?: RawAxiosRequestConfig) {
    return LandingsServiceApiFp(this.configuration)
      .landingsServiceListCampaigns(includeInactive, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary ListLandings — список лендингов из registry.yaml.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LandingsServiceApi
   */
  public landingsServiceListLandings(options?: RawAxiosRequestConfig) {
    return LandingsServiceApiFp(this.configuration)
      .landingsServiceListLandings(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary ListUTMDictionary — допустимые значения меток кампании (DEV-1844). Объявлен ПОСЛЕ GetLanding намеренно: grpc-gateway регистрирует обработчики prepend\'ом, и объявленный позже статический путь перехватывает запрос раньше catch-all /api/v1/landings/{name}. Порядок закреплён тестом.
   * @param {string} [dimension] пусто — все измерения сразу
   * @param {boolean} [includeInactive] include_inactive — показать снятые с эфира значения. Форме выбора они не нужны, экрану управления справочником — нужны.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LandingsServiceApi
   */
  public landingsServiceListUTMDictionary(
    dimension?: string,
    includeInactive?: boolean,
    options?: RawAxiosRequestConfig,
  ) {
    return LandingsServiceApiFp(this.configuration)
      .landingsServiceListUTMDictionary(dimension, includeInactive, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary PublishLanding — триггер публикации (ACTION=publish).
   * @param {string} name
   * @param {object} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LandingsServiceApi
   */
  public landingsServicePublishLanding(
    name: string,
    body: object,
    options?: RawAxiosRequestConfig,
  ) {
    return LandingsServiceApiFp(this.configuration)
      .landingsServicePublishLanding(name, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * ПУБЛИЧНЫЙ метод без авторизации, как и приём просмотра: бьёт скрипт vp-metrics с площадки, в том числе с чужого домена застройщика.  Пачкой, а не по одному: за визит набегают десятки прокруток и кликов, и отдельный запрос на каждый превратил бы приёмник в мишень на ровном месте.  Тот же осознанный риск ADR, что у просмотров: события накручиваемы. Портят только внутреннюю метрику, PII метод не принимает и не хранит.
   * @summary RecordLandingEvents — что посетитель делал на странице (DEV-1865).
   * @param {V1RecordLandingEventsRequest} body RecordLandingEventsRequest — пачка взаимодействий с одной страницы.  Времени в событиях нет намеренно, по той же причине, что и у просмотра: метод публичный, клиентским часам в фактах аналитики доверять нельзя — timestamp ставит приёмник.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LandingsServiceApi
   */
  public landingsServiceRecordLandingEvents(
    body: V1RecordLandingEventsRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return LandingsServiceApiFp(this.configuration)
      .landingsServiceRecordLandingEvents(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Осознанный риск ADR: просмотры накручиваемы. Портит только внутреннюю метрику, PII метод не принимает и не хранит.
   * @summary RecordLandingView — приём просмотра лендинга (DEV-1086, ADR-0022 ред.2 §3.5). ПУБЛИЧНЫЙ метод без авторизации: бьют middleware Cloudflare Pages (внешний рекламный лендинг) и beacon GCS-лендингов. Событие уходит в шину через outbox, analytics считает конверсию по слагу.
   * @param {V1RecordLandingViewRequest} body RecordLandingViewRequest — один просмотр лендинга.  Времени просмотра в запросе нет намеренно: метод публичный, клиентскому времени в фактах аналитики доверять нельзя — timestamp ставит приёмник. Тело от Pages Function содержит лишнее поле viewed_at, gateway его гасит (DiscardUnknown), и это ожидаемо.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LandingsServiceApi
   */
  public landingsServiceRecordLandingView(
    body: V1RecordLandingViewRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return LandingsServiceApiFp(this.configuration)
      .landingsServiceRecordLandingView(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary UnpublishLanding — триггер снятия (ACTION=unpublish).
   * @param {string} name
   * @param {object} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LandingsServiceApi
   */
  public landingsServiceUnpublishLanding(
    name: string,
    body: object,
    options?: RawAxiosRequestConfig,
  ) {
    return LandingsServiceApiFp(this.configuration)
      .landingsServiceUnpublishLanding(name, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary UpdateCampaign — правка кампании. Слаг неизменяем, цель — пока нет ссылок.
   * @param {string} id
   * @param {V1Campaign} campaign
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LandingsServiceApi
   */
  public landingsServiceUpdateCampaign(
    id: string,
    campaign: V1Campaign,
    options?: RawAxiosRequestConfig,
  ) {
    return LandingsServiceApiFp(this.configuration)
      .landingsServiceUpdateCampaign(id, campaign, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Каталог остаётся в registry.yaml, но название оттуда меняется только коммитом в frontend/landings, а описания там нет вовсе. Правка ложится в БД поверх каталога: пустой title возвращает название из реестра.
   * @summary UpdateLanding — правка карточки площадки из CRM: название и описание.
   * @param {string} name
   * @param {LandingsServiceUpdateLandingBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LandingsServiceApi
   */
  public landingsServiceUpdateLanding(
    name: string,
    body: LandingsServiceUpdateLandingBody,
    options?: RawAxiosRequestConfig,
  ) {
    return LandingsServiceApiFp(this.configuration)
      .landingsServiceUpdateLanding(name, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary UpdateLandingContent — полная замена значений слотов. Пустое значение или отсутствие ключа = «как в коде»; значения проверяются по схеме, незнакомый ключ отклоняется. На страницу значения попадают при публикации.
   * @param {string} name
   * @param {object} values values — ключ слота → значение; пустая строка или отсутствие ключа &#x3D; «как в коде».
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LandingsServiceApi
   */
  public landingsServiceUpdateLandingContent(
    name: string,
    values: object,
    options?: RawAxiosRequestConfig,
  ) {
    return LandingsServiceApiFp(this.configuration)
      .landingsServiceUpdateLandingContent(name, values, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary UpdateLandingSeo — полная замена настроек SEO лендинга.
   * @param {string} name
   * @param {V1LandingSeo} seo
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LandingsServiceApi
   */
  public landingsServiceUpdateLandingSeo(
    name: string,
    seo: V1LandingSeo,
    options?: RawAxiosRequestConfig,
  ) {
    return LandingsServiceApiFp(this.configuration)
      .landingsServiceUpdateLandingSeo(name, seo, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary UpsertUTMDictionaryEntry — завести или изменить значение справочника.
   * @param {V1UTMDictionaryEntry} entry
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LandingsServiceApi
   */
  public landingsServiceUpsertUTMDictionaryEntry(
    entry: V1UTMDictionaryEntry,
    options?: RawAxiosRequestConfig,
  ) {
    return LandingsServiceApiFp(this.configuration)
      .landingsServiceUpsertUTMDictionaryEntry(entry, options)
      .then((request) => request(this.axios, this.basePath))
  }
}
